import { Site } from '@models/account/site.model';

import { ApiAdapter } from './adapter';
import { DeliveryPointAdapter } from './delivery-point.adapter';

export class SiteAdapter extends ApiAdapter<Site> {
  private deliveryPointAdapter: DeliveryPointAdapter = new DeliveryPointAdapter();

  get(json): Site {
    const site = new Site({
      id: json['id'],
      labels: {
        internal: json['label_engie'],
        external: json['label_client'] || json['label_engie'],
      },
      address: json['address'],
      country: json['country'],
      accountId: json['account_id'],
      contractIds: json['contract_ids'],
    });

    site.points = (json['points'] || []).map((point) => {
      point = this.deliveryPointAdapter.get({ ...point, site_id: json['id'], site });
      point.siteLabels = site.labels;

      return point;
    });

    return site;
  }
}
